<template>
  <custom-draw width="90%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="bill-draw-body">
      <div class="aside">
        <h1>{{ $t('components_preview_bill_dialog.ji_ben_xin_xi') }}</h1>
        <ul>
          <li>
            <div class="line1">{{ $t('components_preview_bill_dialog.chan_pin_xing_hao') }}</div>
            <div>{{ model.row.productCode }}</div>
          </li>
          <li>
            <div class="line1">{{ $t('components_preview_bill_dialog.she_bei_ji_shen_hao') }}</div>
            <div>{{ model.row.bodyNum }}</div>
          </li>
          <li>
            <div class="line1">{{ $t('components_preview_bill_dialog.zu_lin_shi_chang') }}</div>
            <div>{{ model.row.rentalTerm }}</div>
          </li>
          <li>
            <div class="line1">{{ $t('components_preview_bill_dialog.zhi_fu_zhou_qi') }}</div>
            <div>{{ getDicValue('crm_payment_period', model.row.paymentPeriod) }}</div>
          </li>
          <!--变更起始期 只有变更支付周期有 -->
          <li v-if="model.type === 'change_payment'">
            <div class="line1">{{ $t('components_preview_bill_dialog.bian_geng_qi_shi_qi') }}</div>
            <div>{{ model.row.startChangeTermNum}}</div>
          </li>
          <li>
            <div class="line1">{{ $t('components_preview_bill_dialog.qi_zu_ri_qi') }}</div>
            <div>{{ momentAmPm($momentLocal(model.row.rentalStartTime)) }}</div>
          </li>
          <li>
            <div class="line1">{{ $t('components_preview_bill_dialog.she_bei_dao_qi_ri_qi') }}</div>
            <div>{{ momentAmPm($momentLocal(model.row.endRentDate)) }}</div>
          </li>
          <li>
            <div class="line1">{{ $t('components_preview_bill_dialog.jfsqdb') }}</div>
            <div class="text-right">{{ model.row.partyAName }}</div>
          </li>
          <li>
            <div class="line1">{{ $t('components_preview_bill_dialog.zu_lin_fang') }}</div>
            <div class="text-right">{{ model.row.customerName }}</div>
          </li>
          <li>
            <div class="line1">{{ $t('components_preview_bill_dialog.shou_hou_gong_si') }}</div>
            <div class="text-right">{{ model.row.afterServiceName }}</div>
          </li>
        </ul>
      </div>
      <div class="draw-section">
        <div class="ub-f1">
          <div class="ub-wrap">
            <div class="item-title">
              {{ $t('components_preview_bill_dialog.bgqzd') }}(
              <span v-if="model.type === 'change_afterservice'">{{ model.row.afterServiceName }}</span>
              <span v-if="model.type === 'change_payment'">{{ getDicValue('crm_payment_period', model.row.paymentPeriod) }}</span>
              <span v-if="model.type === 'change_startdate'">{{ momentAmPm($momentLocal(model.row.rentalStartTime)) }}</span>
              <span v-if="model.type === 'change_device'">{{ model.row.bodyNum }}</span>
              )
            </div>
            <!-- {{ tableList }} -->
            <div v-for="(item, index) in tableList" :key="index" style="margin-bottom: 20px">
              <h1>{{ item[0].payableOrgName }}-> {{ item[0].receivableOrgName }}</h1>
              <div class="table-bd">
                <custom-table :data="item" tableCode="previewBill" :filterArr="[$t('components_preview_bill_dialog.ying_fu')]"></custom-table>
              </div>
            </div>
          </div>
        </div>
        <div class="ub-f1">
          <div class="ub-wrap">
            <div class="item-title">
              {{ $t('components_preview_bill_dialog.bghzd') }}(
              <span v-if="model.type === 'change_afterservice'">{{ model.row.newAfterServiceName }}</span>
              <span v-if="model.type === 'change_payment'">{{ getDicValue('crm_payment_period', model.row.newPaymentPeriod) }}</span>
              <span v-if="model.type === 'change_startdate'">{{ momentAmPm($momentLocal(model.row.newRentTime)) }}</span>
              <span v-if="model.type === 'change_device'">{{ model.row.newBodyNum }}</span>
              )
            </div>
            <!-- {{ newTableList }} -->
            <div v-for="(item, index) in newTableList" :key="index" style="margin-bottom: 20px">
              <h1>{{ item[0].payableOrgName }}-> {{ item[0].receivableOrgName }}</h1>
              <div class="table-bd">
                <custom-table :data="item" tableCode="previewBill"  :filterArr="[$t('components_preview_bill_dialog.ying_fu')]" :row-class-name="rowClassName"></custom-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-draw>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import languageInjectMixins from '@/mixins/language_inject_mixins.js';

export default {
  mixins: [languageInjectMixins, dialogMixins],
  data() {
    return {
      form: {},
      rules: {},
      info: {},
      newTableList: [],
      tableList: []
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    rowClassName: function ({ row }) {
      // 只有变更支付周期有
      if (this.model.type === 'change_payment') {
        return +row.termNum >= +this.model.row.startChangeTermNum ? 'current-row' : '';
      }
      return '';
    },
    // 账单分组
    formatGroup: function (list, keyList) {
      const arr = [];
      const keys = {};
      list.forEach((item) => {
        const key = keyList.map(t => item[t]).join('');
        if (keys[key] || keys[key] === 0) {
          arr[keys[key]].push(item);
        } else {
          arr.push([item]);
          keys[key] = arr.length - 1;
        }
      });
      return arr;
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'change_device') {
        this.getChangeDevicePreviewBill();
      }
      if (this.model.type === 'change_afterservice') {
        this.getAfterServicePreviewBill();
      }
      if (this.model.type === 'change_payment') {
        this.getPaymentPreviewBill();
      }
      if (this.model.type === 'change_startdate') {
        this.getStartTimePreviewBill();
      }
    },
    //  获取账单数据(变更设备)
    getChangeDevicePreviewBill: function () {
      const form = {
        bodyNum: '',
        newBodyNum: '',
        deviceId: '',
        newDeviceId: '',
        orderDeviceId: '',
        orderId: '',
        paymentNode: '',
        paymentPeriod: '',
        rentalTerm: '',
        rentalTermUnit: '',
        unitPrice: '',
        recoverPswd: ''
      };
      this.$setFormatData(form, this.model.row);
      this.$postJSON(apis.previewBillChangeDevice, form).then((res) => {
        // 重新排序一下避免收付款顺序不对
        const newBillOrders = res.data.newBillOrders.sort((a, b) => a.payableOrgId - b.payableOrgId);
        const oldBillOrders = res.data.oldBillOrders.sort((a, b) => a.payableOrgId - b.payableOrgId);
        this.newTableList = this.formatGroup(newBillOrders || [], ['payableOrgId', 'receivableOrgId']);
        this.tableList = this.formatGroup(oldBillOrders || [], ['payableOrgId', 'receivableOrgId']);
      });
    },
    //  获取账单数据(变更售后)
    getAfterServicePreviewBill: function () {
      const form = {
        bodyNum: '',
        deviceId: '',
        newServiceId: '',
        newServiceName: '',
        orderDeviceId: '',
        orderId: '',
        paymentNode: '',
        paymentPeriod: '',
        rentalTerm: '',
        rentalTermUnit: '',
        unitPrice: '',
        changeDate: '',
      };
      this.$setFormatData(form, this.model.row);
      form.newServiceId = this.model.row.newAfterServiceId;
      form.newServiceName = this.model.row.newAfterServiceName;
      this.$postJSON(apis.previewBillAfterService, form).then((res) => {
        // 重新排序一下避免收付款顺序不对
        const newBillOrders = res.data.newBillOrders.sort((a, b) => a.payableOrgId - b.payableOrgId);
        const oldBillOrders = res.data.oldBillOrders.sort((a, b) => a.payableOrgId - b.payableOrgId);
        this.newTableList = this.formatGroup(newBillOrders || [], ['payableOrgId', 'receivableOrgId']);
        this.tableList = this.formatGroup(oldBillOrders || [], ['payableOrgId', 'receivableOrgId']);
      });
    },
    //  获取账单数据(支付周期)
    getPaymentPreviewBill: function () {
      const form = {
        beginTime: '',
        bodyNum: '',
        deviceId: '',
        newPaymentPeriod: '',
        orderDeviceId: '',
        orderId: '',
        paymentNode: '',
        paymentPeriod: '',
        rentalTerm: '',
        rentalTermUnit: '',
        unitPrice: '',
        startChangeTermNum: ''
      };
      this.$setFormatData(form, this.model.row);
      this.$postJSON(apis.previewBillPaymentPeriod, form).then((res) => {
        // 重新排序一下避免收付款顺序不对
        const newBillOrders = res.data.newBillOrders.sort((a, b) => a.payableOrgId - b.payableOrgId);
        const oldBillOrders = res.data.oldBillOrders.sort((a, b) => a.payableOrgId - b.payableOrgId);
        this.newTableList = this.formatGroup(newBillOrders || [], ['payableOrgId', 'receivableOrgId']);
        this.tableList = this.formatGroup(oldBillOrders || [], ['payableOrgId', 'receivableOrgId']);
      });
    },
    //  获取账单数据(启租日期)
    getStartTimePreviewBill: function () {
      const form = {
        beginTime: '',
        bodyNum: '',
        deviceId: '',
        orderDeviceId: '',
        orderId: '',
        paymentNode: '',
        paymentPeriod: '',
        rentalTerm: '',
        rentalTermUnit: '',
        unitPrice: ''
      };
      this.$setFormatData(form, this.model.row);
      form.beginTime = this.model.row.newRentTime;
      this.$postJSON(apis.previewBillStartTime, form).then((res) => {
        const newBillOrders = res.data.newBillOrders || [];
        const oldBillOrders = res.data.oldBillOrders || [];
        this.newTableList = this.formatGroup(newBillOrders.filter(t => t.billType !== 11), ['payableOrgId', 'receivableOrgId']);
        this.tableList = this.formatGroup(oldBillOrders.filter(t => t.billType !== 11), ['payableOrgId', 'receivableOrgId']);
      });
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveInsert();
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },
    // 保存新增
    saveInsert: function () {
      this.$postJSON(apis.add, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success'
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑
    saveUpdate: function () {
      this.$postJSON(apis.edit, Object.assign({ id: this.model.data.id }, this.form)).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success'
        });
        this.$emit('success', this.form);
        this.visible = false;
      });
    }
  }
};
</script>

<style lang="scss">
.el-drawer__body {
  height: 0;
}
.bill-draw-body {
  display: flex;
  height: 100%;
  position: relative;
  .aside {
    width: 280px;
    padding: 0 16px;
    height: 100%;
    background: #f8f9fb;
    overflow-y: auto;
    h1 {
      line-height: 60px;
      height: 60px;
      color: #495057;
      font-size: 14px;
    }
    ul > li {
      line-height: 34px;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      color: #6c757d;
      box-shadow: 0px -1px 0px 0px #eef2f7;
      & > div:first-child {
        margin-right: 20px;
      }
      .text-right {
        text-align: right;
        flex: 1;
        line-height: 20px;
        padding: 7px 0;
      }
    }
  }
  .draw-section {
    flex: 1;
    width: 0;
    overflow-x: hidden;
    height: calc(100% - 24px);
    overflow-y: auto;
    padding: 24px 0 72px;
    position: relative;
    display: flex;
    h1 {
      line-height: 50px;
      height: 50px;
      color: #495057;
      font-size: 13px;
    }
    & > .ub-f1:first-child {
      box-shadow: 1px 0px 0px 0px #e9ebec;
    }
    .ub-f1 {
      width: 0;
      padding: 0 14px;
    }
  }
  .footer {
    position: absolute;
    box-shadow: 0px -1px 0px 0px rgba(238, 242, 248, 1);
    left: 280px;
    right: 0;
    bottom: 0;
    height: 60px;
    z-index: 999;
    padding-top: 16px;
    padding-left: 24px;
    background-color: #ffffff;
  }
}
</style>
